// @flow
import * as React from 'react';
import type { RouterHistory } from 'react-router-dom';
import { HistoryContext } from 'routes/RouteProvider';
import { getQueryParams, buildLocationSearch } from 'utils/url';
import type { QueryParams } from 'utils/url';

export type WithRouteChangersInjectedProps = {|
  +refreshLocationState: () => void,
|};

function withRouteChangers<OwnProps>(
  WrappedComponent: React.AbstractComponent<{|
    ...OwnProps,
    ...WithRouteChangersInjectedProps,
  |}>
): React.AbstractComponent<OwnProps> {
  class WithRouteChangers extends React.Component<{|
    _history: RouterHistory,
    ...OwnProps,
  |}> {
    refreshLocationState = () => {
      const { location, replace } = this.props._history;
      const state = { ...location.state, accordionInGrid: false };
      const search = this.updateQueryParams({});
      replace({ state, search });
    };

    getQueryParams = () => getQueryParams(this.props._history.location.search);

    updateQueryParams = (updatedQueryParams: $Shape<QueryParams>) => {
      const queryParams = this.getQueryParams();
      const newQueryParams = { ...queryParams, ...updatedQueryParams };
      return buildLocationSearch(newQueryParams);
    };

    render() {
      const { refreshLocationState } = this;
      const { _history, ...otherProps } = this.props;
      return (
        <WrappedComponent
          {...otherProps}
          refreshLocationState={refreshLocationState}
        />
      );
    }
  }

  return function WithHistory(props) {
    return (
      <HistoryContext.Consumer>
        {(history) => <WithRouteChangers {...props} _history={history} />}
      </HistoryContext.Consumer>
    );
  };
}

export default withRouteChangers;
